<template>
  <div>
    <pageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'master-fabricExpense',
  components: {
    PageTable,
  },
}
</script>
